module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.visibleCategories.length > 0) ? _c('table', {
    staticClass: "d-table marg-1-bottom d-table__overview"
  }, [_c('thead', [_c('tr', [_vm._m(0), _vm._v(" "), _c('th', {
    staticClass: "is-number",
    staticStyle: {
      "width": "70%"
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.assign_users_hours.assigned')))]), _vm._v(" "), (_vm.isShowScheduled) ? _c('th', {
    staticClass: "is-number"
  }, [_vm._v(_vm._s(_vm.$t('vue2.assign_users_hours.scheduled')))]) : _vm._e(), _vm._v(" "), (_vm.isShowScheduled) ? _c('th', {
    staticClass: "is-number"
  }, [_vm._v(_vm._s(_vm.$t('vue2.assign_users_hours.diff')))]) : _vm._e()])]), _vm._v(" "), _c('tbody', _vm._l((_vm.visibleCategories), function(taskCategory) {
    return _c('UserTasksOverviewOwnPoolsPool', {
      attrs: {
        "taskCategory": taskCategory,
        "isShowScheduled": _vm.isShowScheduled,
        "is-date-interval-changed": _vm.isDateIntervalChanged
      }
    })
  }), 1)]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', [_c('h4', [_vm._v("Puljer")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-68d5e0e0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/User/UserTasksOverviewOwnPools.vue
// module id = 1979
// module chunks = 1